import root from '../../_helpers/roots';
import axios from 'axios';
import {
  bus
} from '../../main';
var $ = window.jQuery = require('jquery');
import VueCircle from 'vue2-circle-progress/src/index.vue'
import Vue from 'vue'
export default {
  name: 'quiz-format',
  components: {
    VueCircle
  },
  props: ['quiz', 'totalTime', 'quizInst'],
  data() {
    return {
      fill: {
        color: "#0cbfe9"
      },
      questionIndex: 0,
      userResponses: [],
      quizResponses: [],
      quizStarted: true,
      isActive: false,
      totalScore: 0,
      quizId: '',
      quizSubmitted: false,
      quizStart: false,
      countDown: {
        minutes: "00",
        seconds: "00"
      },
      questionIndexs: ['', 'A', 'B', 'C', 'D'],
      newArray: []
    }
  },
  computed: {

  },
  mounted() {
    $('.quizloader,.courseloader').hide();
    this.quizId = this.$route.params.quizId;
    this.getCounter();
    $(document).ready(function(){
      setTimeout(()=>{
        if(window.MathJax){
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log('done'));
        }
      },100)
    })
    this.renderMathJax()
  },
  methods: {
    renderMathJax(){
      setTimeout(()=>{
        if(window.MathJax){
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log('done'));
        }
      },100)
    },
    getCounter() {
      let startIndex = this.questionIndex;
      let maxCount = 5;
      let maxQuestions = this.quiz.questions.length;
      let finalArray = [];
      let maxNumber = maxCount + startIndex;
      if (maxQuestions > 5) {
        for (let i = startIndex; i < maxNumber; i++) {
          finalArray.push(i + 1);
        }
        if (maxNumber <= maxQuestions)
          this.newArray = finalArray;
      } else {
        for (let i = 0; i < maxQuestions; i++) {
          finalArray.push(i + 1);
        }
        this.newArray = finalArray;
      }
    },
    startQuiz: function() {
      var totalTimes = new Date();
      totalTimes.setSeconds(totalTimes.getSeconds() + this.totalTime);
      this.initializeTimer(totalTimes);
      this.quizStart = true;
      this.renderMathJax();
    },
    submitQuiz: function() {
      $('.quizloader').show();
      let quizCreateAnswerLink = root.quizCreateAnswerLink.link;
      let data = {
        quiz: this.quizId,
        time_taken: (this.totalTime * 1000 - this.countDown.total) / 1000,
        questions: this.quizResponses
      };
      console.log(data);
      axios.post(quizCreateAnswerLink, data).then(response => {
        if (response.status === 201) {
          this.quizSubmitted = true;
          this.totalScore = response.data.data.points_obtained;
          $('.quizloader').hide();
        }
      }).catch(err => {
        console.error(err);
        $('.quizloader').hide();
      })
    },
    selectOption: function(index, optionData, questionId) {
      this.quizResponses.push({
        "question": questionId,
        "options": [{
          "option": optionData
        }]
      })
      Vue.set(this.userResponses, this.questionIndex, index);
    },
    next: function() {
      if (this.questionIndex + 1 == this.quiz.questions.length) {
        this.score()
        this.renderMathJax()
      } else if (this.questionIndex < this.quiz.questions.length) {
        this.questionIndex++;
        this.getCounter();
        this.renderMathJax()
      }
    },
    prev: function() {
      if (this.quiz.questions.length > 0) this.questionIndex--;
      this.renderMathJax()
    },
    // Return "true" count in userResponses
    score: function(showScrore = false) {
      this.submitQuiz();
    },

    //   CountDown
    initializeTimer: function(endTime) {
      var _self = this;
      function updateClock() {
        let remainTime = _self.getTimeRemaining(endTime)
        _self.countDown = remainTime;
        _self.UpdatePercentage(remainTime.total);
        console.log('Time End Before')
        if (remainTime.total <= 0 && _self.quizSubmitted == false) {
          _self.submitQuiz();
          console.log('Time End')
          clearInterval(_self.timeinterval);
        }
      }
      updateClock();
      _self.timeinterval = setInterval(updateClock, 1000);
    },
    getTimeRemaining(endTime) {
      var t = Date.parse(endTime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      return {
        'total': t,
        'minutes': minutes,
        'seconds': seconds
      };
    },
    UpdatePercentage(remainTime) {
      let totalTime = (this.totalTime) * 1000;
      let percentage = 100 - ((remainTime * 100) / totalTime)
      if (this.$refs.timerRef)
        this.$refs.timerRef.updateProgress(percentage);
    }
  },
  beforeDestroy() {
    clearInterval(this.timeinterval);
  },
  created() {
    this.getrenderMathJax;
  },
  watch: {
    getrenderMathJax() {
      this.renderMathJax()
    },
  },
}